import { getApiUrl } from 'modules/Url';

type DeleteMediaFromEpisode = {
  webEpisodeId: string;
};

type DeleteMediaFromEpisodeResponse = {
  episodeId: string;
};

export async function deleteMediaFromEpisode({
  webEpisodeId,
}: DeleteMediaFromEpisode): Promise<DeleteMediaFromEpisodeResponse> {
  try {
    const response = await fetch(
      getApiUrl({
        path: `episodes/webEpisodeId:${webEpisodeId}/clear`,
        queryParameters: {
          returnWebIds: true,
          useAuthV3: true,
        },
      }),
      {
        method: 'POST',
        credentials: 'same-origin',
      }
    );

    if (response.ok) {
      return response.json();
    }
    throw new Error('Error deleting media from episode');
  } catch (e) {
    throw new Error(e.message);
  }
}
